export default __webpack_public_path__ + "media/images/app-icon-7cafa1d743b7f725d8da3b0b11da8d80.svg";